import { FIELD_NAME } from '../constants/form-constants';
import { formService } from '../form-service';

export interface PersonEntity {
	isEmpty: boolean;
	name?: string;
	surname?: string;
	secondSurname?: string;
	email?: string;
	phone?: string;
	prefix?: string;
	treatment?: string;
	dni?: string;
	birthday?: string;
	postalCode?: string;
	city?: string;
	province?: string;
	country?: string;
}

class PersonEntityClass {
	private static instance: PersonEntityClass;

	private constructor() {}

	static getInstance(): PersonEntityClass {
		if (!PersonEntityClass.instance) {
			PersonEntityClass.instance = new PersonEntityClass();
		}
		return PersonEntityClass.instance;
	}

	get isEmpty(): boolean {
		return !this.name && !this.surname && !this.email;
	}

	get name(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.NAME);
	}

	get surname(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.SURNAME_1);
	}

	get secondSurname(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.SURNAME_2);
	}

	get email(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.EMAIL);
	}

	get phone(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.PHONE);
	}

	get phonePrefix(): string {
		return formService.getFieldValue(FIELD_NAME.PHONE_PREFIX) || '';
	}

	get treatment(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.TREATMENT);
	}

	get dni(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.DNI);
	}

	get birthday(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.BIRTHDAY);
	}

	get postalCode(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.CP);
	}

	get city(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.CITY);
	}

	get province(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.PROVINCE);
	}

	get country(): string | undefined {
		return formService.getFieldValue(FIELD_NAME.COUNTRY);
	}
}

export const personEntity = PersonEntityClass.getInstance();
